<script lang="ts">
	import { PUBLIC_GTM } from '$env/static/public';
</script>

<!-- Google Tag Manager (noscript) -->
{#if PUBLIC_GTM}
	{@html `<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=${PUBLIC_GTM}"
        height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>`}
{/if}
<!-- End Google Tag Manager (noscript) -->
